import React from "react"
import {isChrome,isFirefox,isIeEdge,isSafari,getBrowser} from "@tightrope/lpscripts/browserdetect"
import Styles from "./css/chromelpezcomp.module.scss"
import Data from "./data/chromelpezcomp.json"


class chromelpezcomp extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      // Initialize browser flags as false so the SSR-rendered HTML (also false)
      // matches during React 16 hydration. componentDidMount then sets the real values.
      isChrome: false,
      isFirefox: false,
      isIeEdge: false,
      isSafari: false,
      display: 'none',
      pageData: props.data,
      data: Object.assign({}, Data),
      isFading: false,
      // Until LP data merges, hideStepsWhenNotFirefox is not reliable (defaults to false) — do not show steps
      lpDataReady: !props.data,
    }
  }

  showBrowsers(browsers){
    let display = false;
    if(getBrowser() === 'ie' && browsers.includes('ie')){
      display=true;
    }
    if(getBrowser() === 'firefox' && browsers.includes('firefox')){
      display=true;
    }
    if(getBrowser() === 'chrome' && browsers.includes('chrome')){
      display=true;
    }
    if(getBrowser() === 'edge' && browsers.includes('edge')){
      display=true;
    }
    if(getBrowser() === 'other' && browsers.includes('other')){
      display=true;
    }
    if(display)
      this.setState({display: 'block'});
    else
      this.setState({display: 'none'});
  }

  componentDidMount() {
    // Detect the real browser on the client immediately after mount.
    // This must happen outside any async callback so it runs before the first
    // visible paint, preventing a flash of the wrong button state.
    this.setState({
      isChrome: isChrome(),
      isFirefox: isFirefox(),
      isIeEdge: isIeEdge(),
      isSafari: isSafari(),
    });

    if(this.props.browsers){
      this.showBrowsers(this.props.browsers);
    }
    else{
      this.setState({display: 'block'});
    }
    if(this.props.data){
      this.props.data.then(data => {
        let merged = Object.assign({}, this.state.data, data);
        if (isChrome() && merged.chrome) {
          merged = Object.assign({}, merged, merged.chrome);
        } else if (isFirefox() && merged.firefox) {
          merged = Object.assign({}, merged, merged.firefox);
        }
        this.setState({
          data: merged,
          lpDataReady: true,
        });
      });
    }
  }

  render() {
    return (
      <>
      <div id = {Styles.chromelpezcomp}>

        <div className = {Styles.header}><img src="/img/logo.png" alt="" /></div>
     <div className = {Styles.main}>
       <h1 className = "hc_param">{this.state.data.headline}</h1>

      <div className = {Styles.stepGrid}>
        <div className = {Styles.copy}>
          <h2>{this.state.data.subhead1}</h2>
          <p>{this.state.data.copy1}</p>
        </div>

        <div className = {Styles.copy}>
          <h2>{this.state.data.subhead2}</h2>
          <p>{this.state.data.copy2}</p>
        </div>
      </div>
       {this.props.children}
       <button
         className={`${Styles.download} cl1`}
         type="button"
         disabled={(this.state.isChrome || this.state.isSafari || this.state.isIeEdge) || this.state.data.disableCta === true}
         onClick={(this.state.isChrome || this.state.isSafari || this.state.isIeEdge) ? undefined : (this.state.data.disableCta === true ? undefined : () => window.triggerInstall())}
         data-cy="cta"
       >{(this.state.isChrome || this.state.isSafari || this.state.isIeEdge) ? 'Browser not supported' : this.state.data.button}</button>
      </div>
        </div>


      </>
    )
  }
}
export default chromelpezcomp
